'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  ADD_NOTIFICATION: null,
  REMOVE_NOTIFICATION: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ReduxMessenger/static-2.618/js/actions/ActionTypes.js
// module id = 469
// module chunks = 0